import script from "./MenuManager.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuManager.vue?vue&type=script&setup=true&lang=js"

import "./MenuManager.vue?vue&type=style&index=0&id=10c374b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c374b6"]])

export default __exports__